import { CellType } from './cell'
import { lineFromVehicle } from '../lineAppearance'

const scheduledOriginCellFromTicketsHop = (response, hopIndex) => {
  const hop = response.hops[hopIndex]

  const line = response.lines[hop.line]
  const placeIndex = line.places[0]
  const place = response.places[placeIndex]
  const vehicle = response.vehicles[hop.vehicle]

  return {
    type: CellType.Origin,
    primaryText: place.name,
    ...(place.code) && { airportCode: place.code },
    localTime: hop.departureTime,
    line: lineFromVehicle(vehicle.kind),
  }
}

const scheduledOriginCellFromCheckoutHop = (hop) => {
  return {
    type: CellType.Origin,
    primaryText: hop.origin,
    ...(hop.code) && { airportCode: hop.origin.code },
    localTime: hop.departureTime.substring(11, 16),
    line: lineFromVehicle(hop.kind),
  }
}

export {
  scheduledOriginCellFromTicketsHop,
  scheduledOriginCellFromCheckoutHop
}
